import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { openToastify } from 'components/toast/OpenToast';
import { getClientSecret, postAddPayMethod } from 'services/stepsAPI';

const initialState: {
  addPayMethod: {
    data: any;
    status: string;
  };
  isCheckout: {
    data: boolean;
    status: string;
  };
  clientSecret: {
    data: any;
    status: string;
  };
} = {
  addPayMethod: {
    data: null,
    status: 'idle'
  },
  isCheckout: {
    data: false,
    status: 'idle'
  },
  clientSecret: {
    data: null,
    status: 'idle'
  }
};

export const postAddPayMethodState = createAsyncThunk(
  'checkout/postAddPayMethod',
  async (body: any) => {
    try {
      const response: any = await postAddPayMethod(body);
      return response.data;
    } catch (error: any) {
      openToastify('danger', 'something_missing', error?.data?.msg);
      return Promise.reject(error.data ? error.data : error);
    }
  }
);

export const getClientSecretState = createAsyncThunk('checkout/getClientSecretState', async () => {
  try {
    const response: any = await getClientSecret();
    return response.data;
  } catch (error: any) {
    openToastify('danger', 'something_missing', error?.data?.msg);
    return Promise.reject(error.data ? error.data : error);
  }
});

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setIsCheckout: (state, action) => {
      state.isCheckout.data = action.payload;
    },
    resetAddPayMethod: (state) => {
      state.addPayMethod.data = null;
    },
    resetIsCheckout: (state) => {
      state.isCheckout.data = false;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(postAddPayMethodState.pending, (state) => {
        state.addPayMethod.status = 'loading';
      })
      .addCase(postAddPayMethodState.fulfilled, (state, action) => {
        state.addPayMethod.status = 'success';
        state.addPayMethod.data = action.payload;
        localStorage.clear();
      })
      .addCase(postAddPayMethodState.rejected, (state, action) => {
        state.addPayMethod.status = 'rejected';
        state.addPayMethod.data = action.error;
      })
      .addCase(getClientSecretState.rejected, (state, action) => {
        state.clientSecret.status = 'rejected';
        state.clientSecret.data = action.error;
      })
      .addCase(getClientSecretState.pending, (state) => {
        state.clientSecret.status = 'loading';
      })
      .addCase(getClientSecretState.fulfilled, (state, action) => {
        state.clientSecret.status = 'success';
        state.clientSecret.data = action.payload.results;
      });
  }
});

export const { setIsCheckout, resetAddPayMethod, resetIsCheckout } = checkoutSlice.actions;
export const checkoutState = (state: RootState) => state.checkout;
export const isCheckoutState = (state: RootState) => state.checkout.isCheckout;
export const addPayMethodState = (state: RootState) => state.checkout.addPayMethod;
export const clientSecretState = (state: RootState) => state.checkout.clientSecret;

export default checkoutSlice.reducer;
